import {
  Anchor,
  Avatar,
  CloseButton,
  Divider,
  Group,
  Paper,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import {
  IconBrandLinkedin,
  IconBriefcase,
  IconBuildingCommunity,
  IconPhone,
  IconUserPlus,
  IconWorld,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { parseDate } from "../../../../../functions/dates";
import { IconEmail } from "../../../../../assets/icons/IconEmail";

const ContactPreview = ({ contact, setContact }) => {
  const lang = useLanguage((s) => s.language);

  return (
    <Paper
      component={Stack}
      gap={"xs"}
      p={"md"}
      pos={"absolute"}
      top={0}
      right={contact ? 0 : -300}
      style={{
        overflow: "hidden",
        border: "1px solid var(--mantine-color-primary-0)",
        zIndex: 200,
        transition: "all ease .3s",
      }}
      shadow="sm"
      h={"calc(100% - 52px)"}
      w={300}
      opacity={contact ? 1 : 0}
    >
      <CloseButton
        onClick={() => setContact(null)}
        mt={-8}
        size={"md"}
        mb={-8}
      />
      <Group wrap="nowrap">
        <Avatar
          name={(contact?.["3"] || " - ") + " " + (contact?.["4"] || " - ")}
          color="initials"
          src={contact?.["40"]}
          mr={4}
          imageProps={{
            referrerPolicy: "no-referrer",
          }}
          size={64}
        />
        <Stack gap={0} w={"100%"}>
          <Text fw={700} truncate="end" maw={150} display={"block"}>
            {(contact?.["3"] || " - ") + " " + (contact?.["4"] || " - ")}
          </Text>

          <Group c={"dimmed"} mt={4} gap={6} ml={-6} wrap="nowrap">
            <Tooltip label={lang.prospects.contact_preview.company}>
              <ThemeIcon variant="subtle">
                <IconBuildingCommunity size={16} />
              </ThemeIcon>
            </Tooltip>

            <Text fw={400} size="sm">
              {contact?.["12"] || " - "}
            </Text>
          </Group>

          <Group c={"dimmed"} gap={6} ml={-6} wrap="nowrap">
            <Tooltip label={lang.prospects.contact_preview.created_on}>
              <ThemeIcon variant="subtle">
                <IconUserPlus size={16} />
              </ThemeIcon>
            </Tooltip>

            <Text fw={400} size="sm" style={{ wordWrap: "break-word" }}>
              {contact?.["created_on"]
                ? parseDate(contact?.["created_on"])
                : " - "}
            </Text>
          </Group>
        </Stack>
      </Group>

      <Divider />
      <Stack>
        <Group wrap="nowrap">
          <ThemeIcon color="secondary" radius={"xl"}>
            <IconEmail size={16} />
          </ThemeIcon>
          <Stack gap={0}>
            <Text size="sm" fw={600}>
              {lang.prospects.contact_preview.email}
            </Text>
            <Text size="md" truncate w={175}>
              {contact?.["1"] || " - "}
            </Text>
          </Stack>
        </Group>

        <Group wrap="nowrap">
          <ThemeIcon color="blue" radius={"xl"}>
            <IconBrandLinkedin size={16} />
          </ThemeIcon>
          <Stack gap={0}>
            <Text size="sm" fw={600}>
              LinkedIn
            </Text>
            <Anchor
              href={contact?.["20"]}
              target="_blank"
              size="md"
              truncate
              w={175}
            >
              {contact?.["20"] || " - "}
            </Anchor>
          </Stack>
        </Group>

        <Group>
          <ThemeIcon color="#999" radius={"xl"}>
            <IconPhone size={16} />
          </ThemeIcon>
          <Stack gap={0}>
            <Text size="sm" fw={600}>
              {lang.prospects.contact_preview.phone}
            </Text>
            <Text size="md">{contact?.["6"] || " - "}</Text>
          </Stack>
        </Group>

        <Group wrap="nowrap">
          <ThemeIcon color="#999" radius={"xl"}>
            <IconBriefcase size={16} />
          </ThemeIcon>
          <Stack gap={0}>
            <Text size="sm" fw={600}>
              {lang.prospects.contact_preview.function}
            </Text>
            <Text size="md" w={175}>
              {contact?.["11"] || " - "}
            </Text>
          </Stack>
        </Group>

        <Group wrap="nowrap">
          <ThemeIcon color="#999" radius={"xl"}>
            <IconWorld size={16} />
          </ThemeIcon>
          <Stack gap={0}>
            <Text size="sm" fw={600}>
              {lang.prospects.contact_preview.country}
            </Text>
            <Text size="md" w={175}>
              {contact?.["31"] || " - "}
            </Text>
          </Stack>
        </Group>
      </Stack>
    </Paper>
  );
};

export default ContactPreview;
